<script lang="ts">
	//Hooks
	import { createEventDispatcher, onDestroy } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Icon } from '@Shelly/shelly-design-system';

	export let expanded = false,
		debounceTimeout = 250,
		addressError = '';

	export const open = () => {
			expanded = true;
			inputField.focus();
		},
		close = (value: string) => {
			expanded = false;
			clearTimeout(timeoutId);
			inputField.value = value;
			inputField.blur();
		},
		reset = () => {
			inputField.value = '';
		};

	let timeoutId: NodeJS.Timeout, inputField: HTMLInputElement;

	const dispatch = createEventDispatcher(),
		onInputHandler = (e) => {
			addressError = '';
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				dispatch('input', e.target.value);
			}, debounceTimeout);
		};

	onDestroy(() => {
		clearTimeout(timeoutId);
	});
</script>

<div class:expanded class={`input-wrapper ${addressError ? 'error' : ''}`}>
	<div class="search-field-box">
		<Icon size="s" icon="fas fa-home" />
		<input
			type="text"
			placeholder={$format('premium_invoice_details_address', {
				default: 'Address name',
			})}
			autocomplete="off"
			on:focus={() => {
				((expanded = true), (addressError = ''));
			}}
			on:input={onInputHandler}
			bind:this={inputField}
		/>
	</div>
	<slot />
</div>
{#if addressError}
	<span class="validation-text">
		{addressError}
	</span>
{/if}

<style>
	.input-wrapper {
		position: relative;
		background: var(--color-base);
		border-radius: var(--radius-small);
		overflow: hidden;
		width: 100%;
		border: 1px solid var(--color-3);
		max-height: calc(100% - 20px);
		display: flex;
		flex-direction: column;
	}

	.input-wrapper.input-wrapper.error {
		border-color: var(--color-danger); /* Change border color when error */
	}
	.input-wrapper.expanded {
		box-shadow: var(--shadow-glow-soft);
		border: 1px solid var(--color-primary);
	}
	.search-field-box {
		padding: 0 5px;
		display: flex;
		align-items: center;
		background: var(--color-base);
	}
	input {
		position: relative;
		height: 32px;
		opacity: 0;
		width: 0;
		position: relative;
		margin: 0;
		padding: 0;
		border: none;
		outline: none;
		transition: width 0.33s;
		color: var(--color-white);
		background: var(--color-base);
		border-radius: var(--radius-small);
		border-left: none;
		font-family: var(--font-family);
		font-size: 13px;
		line-height: 16px;
	}

	input::placeholder {
		font-family: var(--font-family);
		font-size: 13px;
		line-height: 16px;
		font-style: italic;
		color: var(--color-muted);
	}
	.input-wrapper input {
		opacity: 1;
		position: relative;
		padding: 0 10px 0 5px;
		width: 100%;
	}

	.validation-text {
		font-family: var(--font-family);
		font-style: normal;
		font-weight: normal;
		font-size: 10px;
		line-height: 12px;
		color: var(--color-white);
		margin: 0;
		margin-top: var(--spacing-xxs);
		margin-left: 6px;
		color: var(--color-danger);
	}
</style>
